import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  getFirestore,
  doc,
  collection,
  onSnapshot,
  setDoc,
  deleteDoc,
  serverTimestamp
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBD0l8fSuAtt5zjCc5Uy_Xrhl-iDrv81rk',
  authDomain: 'vittalink-app.firebaseapp.com',
  projectId: 'vittalink-app',
  storageBucket: 'vittalink-app.firebasestorage.app',
  messagingSenderId: '826911622139',
  appId: '1:826911622139:web:0cadacc92b4be90ed2815e',
  measurementId: 'G-QKV3CV987H'
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

/**
 * Subscribe in real time to the Web Video Media configuration from Firestore config/web_media
 */
export const subscribeToWebVideo = (onUpdate, onError) => {
  try {
    const docRef = doc(db, 'config', 'web_media');
    return onSnapshot(
      docRef,
      (docSnap) => {
        if (docSnap.exists()) {
          onUpdate(docSnap.data());
        }
      },
      (err) => {
        console.warn('Firestore web media snapshot warning:', err);
        if (onError) onError(err);
      }
    );
  } catch (err) {
    console.error('Error listening to web media config:', err);
    if (onError) onError(err);
    return () => {};
  }
};

/**
 * Subscribe in real time to Catalog Products from Firestore collection 'catalog_products'
 */
export const subscribeToCatalogProducts = (onUpdate, onError) => {
  try {
    const colRef = collection(db, 'catalog_products');
    return onSnapshot(
      colRef,
      (snapshot) => {
        if (snapshot.empty) {
          onUpdate([]);
          return;
        }
        const products = snapshot.docs.map((docSnap) => ({
          ...docSnap.data(),
          id: docSnap.id
        }));
        onUpdate(products);
      },
      (err) => {
        console.warn('Firestore Catalog Products listener warning:', err);
        if (onError) onError(err);
      }
    );
  } catch (err) {
    console.error('Error connecting to Firestore catalog_products collection:', err);
    if (onError) onError(err);
    return () => {};
  }
};

/**
 * Save or update a product document in Firestore 'catalog_products'
 */
export const saveCatalogProductToFirestore = async (product) => {
  try {
    const docRef = doc(db, 'catalog_products', String(product.id));
    await setDoc(docRef, { ...product, updatedAt: serverTimestamp() }, { merge: true });
    return true;
  } catch (err) {
    console.warn('Firestore save catalog product failed (falling back to local):', err);
    return false;
  }
};

/**
 * Delete a product document from Firestore 'catalog_products'
 */
export const deleteCatalogProductFromFirestore = async (productId) => {
  try {
    const docRef = doc(db, 'catalog_products', String(productId));
    await deleteDoc(docRef);
    return true;
  } catch (err) {
    console.warn('Firestore delete catalog product failed (falling back to local):', err);
    return false;
  }
};

// Master dashboard data. Reads are public for the website; Firestore rules
// must restrict every write to users with the Firebase `admin` custom claim.
export const subscribeToVendingMachines = (onUpdate, onError) => {
  return onSnapshot(collection(db, 'vendingMachines'), (snapshot) => {
    onUpdate(snapshot.docs.map((machineDoc) => ({ ...machineDoc.data(), id: machineDoc.id })));
  }, onError);
};

export const saveVendingMachine = async (machine) => {
  const { id, ...data } = machine;
  await setDoc(doc(db, 'vendingMachines', String(id)), { ...data, id: String(id), updatedAt: serverTimestamp() }, { merge: true });
};

export const deleteVendingMachine = async (machineId) => {
  await deleteDoc(doc(db, 'vendingMachines', String(machineId)));
};

// Admin versions throw errors to display permission/network failures clearly.
export const saveCatalogProductForAdmin = async (product) => {
  await setDoc(doc(db, 'catalog_products', String(product.id)), { ...product, updatedAt: serverTimestamp() }, { merge: true });
};

export const deleteCatalogProductForAdmin = async (productId) => {
  await deleteDoc(doc(db, 'catalog_products', String(productId)));
};
